export const getURLParam = (name, customSearch) => {
  const search = customSearch ? customSearch : location.search
  const value = search.match(new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i'))
  return value ? decodeURIComponent(value[1]) : ''
}

export const isDev = process.env.NODE_ENV === 'development'
console.log('process.env.NODE_ENV', process.env.NODE_ENV)
export const isTest = process.env.TEST
export const isPre = process.env.IS_PRE
export const isPro = (!isDev && !isTest && !isPre) || getURLParam('pro') === '1'
export const isDebug = !isPro || getURLParam('debug') === '1'
export const isMock = getURLParam('mock') === '1'

export const videoUI = 'huyaVideoUI'
export default {
  getURLParam,
  isDev,
  isTest,
  isPre,
  isPro,
  isDebug,
  isMock,
  videoUI,
}
